import { useCallback, useEffect, useState } from 'react';
import { analyticsService } from '../services/analyticsService';

export default function useFieldFilterValues(fieldId, campaignIds = [], leadsFormIds = []) {
  const [values, setValues] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const load = useCallback(async () => {
    if (!fieldId || !campaignIds.length) {
      setValues([]);
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    const res = await analyticsService.getFieldValues(fieldId, campaignIds, leadsFormIds);
    setValues(res.ok ? res.data?.values || [] : []);
    setIsLoading(false);
  }, [fieldId, campaignIds, leadsFormIds]);

  useEffect(() => {
    load();
  }, [load]);

  return { values, isLoading, reload: load };
}
